import { IMediaList } from "@/interfaces";
import { BlogPagination } from "../../blog/BlogPagination"
import { BlogSearchBar } from "../../blog/BlogSearchBar"
import { MediaTile } from "../MediaTile"
import styles from '../../blog/blog.module.css'
import { useEffect, useState } from "react";
import { useGlobalContext } from "@/libs/context/GlobalContext";
import { useRouter } from "next/router";
type props = {
    mediaData: IMediaList
}
export function MediaPosts({ mediaData }: props) {
    const [data, setData] = useState(mediaData);
    const posts = data.media || data.posts;
    const router = useRouter();
    useEffect(() => {
        setData(mediaData)
    }, [router.query])
    const { props: { siteUrl } } = useGlobalContext();
    return <section className={styles.my_blog}>
        <div className="container">
            <BlogSearchBar setData={setData} />
            <div id="all-blog-post" className={`${styles.tab_content} tab-content-1 ${styles.active}`}>
                <div className={styles.blog_grid}>
                    {posts && posts.length > 0 && posts.map((f, idx) =>
                        <MediaTile key={idx} data={f} />
                    )}
                </div>
            </div>
            {posts.length === 0 && <div style={{ justifyContent: 'center', fontSize: 'initial' }}>Sorry, No Posts Found <a href={`${siteUrl}/media`} style={{ textDecoration: 'underline' }}>Back to Media Page</a></div>}
            <BlogPagination totalPageCount={data.paginationData.totalPages} />
        </div>
    </section>
}